import 'bootstrap/js/tab';

import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Message from 'models/message';
import MessagesView from 'views/coach_messages';
import PermissionCollection from 'collections/permission';
import GoogleAnalytics from 'core/google_analytics';


export default Backbone.View.extend({
  events: {
    'click a.revoke': 'revoke_permission',
    'click #delete-contact button': 'delete_contact'
  },

  initialize: function (options) {
    _.bindAll(this, 'render', 'set_coach', 'back_to_list', 'has_section',
      'grant_permission', 'revoke_permission', 'received_message',
      'added_permission', 'removed_permission', 'delete_contact');

    this.template = _.template($('#coach-detail-tmpl').html());
    this.grant_modal = $('#grant-modal');

    this.coachhub = options.coachhub;
    this.user = this.coachhub.coachhub_user;
    this.domains = this.coachhub.domains;
    this.contacts = this.coachhub.contacts;
    this.permissions = new PermissionCollection();
    if (this.user.can_contact_coaches()) {
      this.permissions.fetch();
    }
    this.permissions.on('add', this.added_permission);
    this.permissions.on('remove', this.removed_permission);

    this.coachhub.on('new-message', this.received_message);
    $('.grant', this.grant_modal).on('click', this.grant_permission);
    this.coach_list_el = this.coachhub.coach_list_el.parent();
  },

  set_coach: function (coach, dtl_options) {
    this.model = coach;
    this.permission = this.permissions.findWhere({
      coach: this.model.get('user').url
    });
    if (dtl_options) {
      this.dtl_options = dtl_options;
    } else {
      var contact = this.coachhub.contacts.find(function (contact) {
        return contact.get('user').id == this.model.get('user').id;
      }, this);
      this.dtl_options = { nav: 'profile', is_contact: Boolean(contact) };
    }
    this.render();
    this.permission_el = $('#permission', this.el);
    this.trigger('changed_model', this.model.get('user').id);
  },

  render: function () {
    this.coach_list_el.hide();

    // Populate the coach detail information on the page
    var sections = [ 'about_me', 'experience', 'education',
      'achievements', 'affiliations', 'testimonials' ];
    this.$el.html(this.template(_.extend(this.dtl_options, {
      coach: this.model,
      domains: this.domains,
      permission: this.permission,
      can_contact_coaches: this.user.can_contact_coaches(),
      // Filter sections down to just what the coach has data for
      sections: _.filter(sections, this.has_section)
    })));
    new MessagesView({
      el: $('#messages', this.$el),
      user: this.model.get('user'),
      coachhub: this.coachhub
    });

    // Scroll to the top of the element if necessary
    var doc = $(document);
    doc.scrollTop(_.min([ doc.scrollTop(), this.$el.offset().top ]));

    // Clicking back-to-list should return to the list view
    $('.back-to-list', this.$el).click(this.back_to_list);
  },

  has_section: function (section) {
    if (section == 'about_me') {
      return this.model.get(section) != '';
    }
    return this.model.get(section).length > 0;
  },

  back_to_list: function (e) {
    if (e) {
      e.preventDefault();
    }
    this.$el.html('');
    this.coach_list_el.show();
    this.model = null;
    this.trigger('closed');
  },

  added_permission: function (permission) {
    if (this.model && this.model.get('user').url == permission.get('coach')) {
      this.permission = permission;
      this.permission_el.addClass('granted');
    }
  },

  removed_permission: function (permission) {
    if (this.model && this.model.get('user').url == permission.get('coach')) {
      this.permission_el.removeClass('granted');
    }
  },

  received_message: function (data) {
    var message = new Message(data.message);
    if (!message.from_me()) {
      return;
    }
    var permission_cats = [ 'permission-grant', 'permission-revoke' ];
    if (_.contains(permission_cats, message.get('category'))) {
      // Permission has been granted or revoked, refresh the
      // permissions collection to update the page
      this.permissions.fetch();
    }
  },

  grant_permission: function () {
    GoogleAnalytics.send_event('button', 'click', 'grant-access');
    this.permissions.create({
      coach: this.model.get('user').url,
      provider: 'moodhacker'
    }, { wait: true });
  },

  revoke_permission: function (e) {
    e.preventDefault();
    $(e.currentTarget).blur();
    this.permission.destroy();
  },

  delete_contact: function () {
    var user_id = this.model.get('user').id;
    var contact = this.contacts.find(function (model) {
      return model.get('user').id == user_id;
    });
    this.back_to_list();
    contact.destroy();
  }
});



// WEBPACK FOOTER //
// ./static/js/views/coach_detail.js